import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function Envelope({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Envelope.Outline {...props} />
  ) : (
    <Envelope.Solid {...props} />
  );
}

Envelope.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          className="icon-outline"
          d="M18.5864 9.18945L14.1431 12.8025C13.3037 13.4685 12.1225 13.4685 11.283 12.8025L6.80225 9.18945"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="icon-outline"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5927 21.3383C20.6341 21.3468 22.6838 18.8479 22.6838 15.7767V8.90839C22.6838 5.8372 20.6341 3.33838 17.5927 3.33838H7.77497C4.73362 3.33838 2.68384 5.8372 2.68384 8.90839V15.7767C2.68384 18.8479 4.73362 21.3468 7.77497 21.3383H17.5927Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Envelope.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          className="icon-secondary"
          d="M22.6838 15.9669C22.6838 18.7569 20.4438 21.0169 17.6538 21.0269H17.6438H7.73384C4.95384 21.0269 2.68384 18.7769 2.68384 15.9869V15.9769C2.68384 15.9769 2.68984 11.5509 2.69784 9.32486C2.69884 8.90686 3.17884 8.67286 3.50584 8.93286C5.88184 10.8179 10.1308 14.2549 10.1838 14.2999C10.8938 14.8689 11.7938 15.1899 12.7138 15.1899C13.6338 15.1899 14.5338 14.8689 15.2438 14.2889C15.2968 14.2539 19.4508 10.9199 21.8628 9.00386C22.1908 8.74286 22.6728 8.97686 22.6738 9.39386C22.6838 11.6029 22.6838 15.9669 22.6838 15.9669Z"
        />
        <path
          className="icon-primary"
          d="M22.16 5.70025C21.294 4.06825 19.59 3.02625 17.714 3.02625H7.73397C5.85797 3.02625 4.15397 4.06825 3.28797 5.70025C3.09397 6.06525 3.18597 6.52025 3.50897 6.77825L10.934 12.7172C11.454 13.1372 12.084 13.3462 12.714 13.3462C12.718 13.3462 12.721 13.3462 12.724 13.3462C12.727 13.3462 12.731 13.3462 12.734 13.3462C13.364 13.3462 13.994 13.1372 14.514 12.7172L21.939 6.77825C22.262 6.52025 22.354 6.06525 22.16 5.70025Z"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
